import React, {useEffect, useState} from 'react';
import {Modal, Divider, Space} from 'antd';
import {apiGetStatistical} from "../../api";
import { useLoading } from '../../context/LoadingContext'
import moment from "moment";
import {formatDate} from "../../utils/entity-utils";
import {formatCurrency} from "../../utils/string-utils";

type FieldModalView = {
    isOpen: boolean,
    id: string | null,
    setOpenModal: Function
}

const ViewStatistical = ({ isOpen, id, setOpenModal }: FieldModalView) => {
    const [data, setCurrentStatistical] = useState<any>(null);
    const { setIsLoading } = useLoading();

    const getStatistical =  async (id: string) => {
        try {
            setIsLoading(true)
            const resData = await apiGetStatistical({
                id: id
            });
            if(resData.data.partnerStatistical !== null) {
                setCurrentStatistical(resData.data.partnerStatistical);
            }
        } catch (error) {
            console.error('Failed to fetch statistical data:', error);
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (id) {
            getStatistical(id);
        }
    }, [id]);

    const getStatisticalDay = () => {
        const date = moment([data?.year, data?.month, data?.day]);
        return date.format('DD/MM/YYYY');
    }

    return (
        <Modal
            className='custom-modal-width'
            title='Chi tiết thống kê'
            open={isOpen}
            onCancel={() => setOpenModal(false)}
            footer={[]}
        >
            <Divider />
            <Space>
                <h3 style={{ margin: 0 }}>Gói cước đối tác:</h3>
                <span>{data?.cpCode}</span>
            </Space>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: 10 }}>
                <div>
                    <p><b>Ngày thống kê: </b>{getStatisticalDay()}</p>
                    <p><b>Bán trong ngày: </b>{formatCurrency(data?.revenue)}</p>
                    <p><b>Hoàn tiền trong ngày: </b>{formatCurrency(data?.refund)}</p>
                </div>
                <div>
                    <p><b>Dư đầu ngày: </b>{formatCurrency(data?.balanceStartDate)}</p>
                    <p><b>Bán trong ngày sau CK: </b>{formatCurrency(data?.revenueNet)}</p>
                    <p><b>Thời gian tạo: </b>{formatDate(data?.createdAt)}</p>
                </div>
                <div>
                    <p><b>Dư cuối ngày: </b>{formatCurrency(data?.balanceEndDate)}</p>
                    <p><b>Nạp trong ngày: </b>{formatCurrency(data?.deposit)}</p>
                    <p><b>Cập nhật: </b>{formatDate(data?.updatedAt)}</p>
                </div>
            </div>
            <span><b>Mô tả: </b>{data?.description}</span>
            <Divider />
        </Modal>
    );
};

export default ViewStatistical;
